import React, { Component, Fragment } from 'react';
import ClassNames from 'classnames';

import Dropdown from 'Components/Dropdown';

import { 
    CARGO_DETAILS,
    HANDLING_INSTRUCTIONS,
    CARGO_TYPE,
    HIKAL,
    CARGIL,
    GALAXY_SURFACE,
    DEEPAK_PHENOLICS,
    DEEPAK_PHENOLICS_SAP
 } from 'Constants/commonConstants';

import { ReactComponent as SolidIcon } from 'Icons/solid.svg'
import { ReactComponent as LiquidIcon } from 'Icons/liquid.svg'
import { ReactComponent as PackedLiquidIcon } from 'Icons/packed-liquid.svg'
import { ReactComponent as GasIcon } from 'Icons/gas.svg'
import { ReactComponent as HazardousIcon } from 'Icons/hazardous.svg'
import { ReactComponent as Others } from 'Icons/others.svg'


import { ReactComponent as NormalIcon } from 'Icons/normal.svg'
import { ReactComponent as TemperatureSensitiveIcon } from 'Icons/temp-sensitive.svg'
import { ReactComponent as Sunlight } from 'Icons/sunlight.svg'
import { ReactComponent as HygroscopicIcon } from 'Icons/hygroscopic.svg'
import { ReactComponent as HandleWithCareIcon } from 'Icons/handle-with-care.svg'
import { ReactComponent as VerticalLoadingIcon } from 'Icons/vertical-loading.svg'
import { ReactComponent as ImpactSensitiveIcon } from 'Icons/impact-sensitive.svg'
import { ReactComponent as ForkLiftIcon } from 'Icons/fork-lift.svg'
import { ReactComponent as HydraIcon } from 'Icons/hydra.svg'
import { ReactComponent as CraneIcon } from 'Icons/crane.svg'

import Input from 'Components/Input/index';

import TemperatureCard from 'Components/TemperatureCard';
import OutsideClickHandler from 'react-outside-click-handler';

import { IS_RIL_RETAIL } from 'Constants/commonConstants';
import { getCompanyName, getUser } from 'Utils/storage';
import { toPascalCase } from '../../utils/validate';
import Checkbox from 'Components/Checkbox';
import Select from 'react-select';
import { isDesmet, isMITSUI } from 'Utils/index';
import CargoDescription from 'Pages/SupplierRFQCreateOrUpdateRequest/CargoDescription';
import { Spacer } from 'Components/Common/Spacer/index';

class CargoInformation extends Component {
    constructor(props) {
        super(props);
        this.cargoInfo = props.cargoInfo;
        this.material_packing_list = props.material_packing_list;
        this.state = {
            isTemperatureCardShown : false,
            cargoInfo: this.cargoInfo,
        }
        this.viewMode = props.viewMode;
    }
    toggleCargo = (e)=> {
        if(this.viewMode) {
            return;
        }
        const cargoValue = parseInt(e.currentTarget.getAttribute('name'));
        const cargoDetails = [...this.cargoInfo.cargoDetails];
        const index = cargoDetails.indexOf(cargoValue);
        if(index < 0) {
            cargoDetails.push(cargoValue);
        } else {
            cargoDetails.splice(index, 1);
        }
        this.cargoInfo.setCargoDetails(cargoDetails);
        this.setState({
            cargoInfo: this.cargoInfo
        })
        this.props.onChange();
    }
    toggleInstructions = (e)=> {
        if(this.viewMode) {
            return;
        }
        const isntructionValue = parseInt(e.currentTarget.getAttribute('name'));
        const handlingInstructions = [...this.cargoInfo.handlingInstructions];
        const index = handlingInstructions.indexOf(isntructionValue);
        if(index < 0) {
            handlingInstructions.push(isntructionValue);
            if(isntructionValue === 2) {
                this.showTemperatureCard();
            }
        } else {
            handlingInstructions.splice(index, 1);
        }
        this.cargoInfo.setHandlingInstructions(handlingInstructions);
        this.setState({
            cargoInfo: this.cargoInfo
        });
        this.props.onChange();
    }
    selectPackingType = (packingType, isMulti)=> {
        if(this.viewMode) {
            return;
        }
        if(isMulti) {
            this.cargoInfo.setPackingType(packingType, null, isMulti);
        } else {
            this.cargoInfo.setPackingType(packingType.value, packingType.name);
        }
        this.setState({
            cargoInfo: this.cargoInfo
        })
        this.props.onChange();
    }
    selectProductCategory = (productCategory, isMulti)=> {
        if(this.viewMode) {
            return;
        }
        if(isMulti) {
            this.cargoInfo.setProductCategory(productCategory, null, isMulti);
        } else {
            this.cargoInfo.setProductCategory(productCategory.value, productCategory.name);
        }
        this.cargoInfo.setProductDensity(productCategory.density);
        this.setState({
            cargoInfo: this.cargoInfo
        })
        this.props.onChange();
    }
    showTemperatureCard = ()=> {
        this.setState({
            isTemperatureCardShown: true
        });
    }
    saveTemperatureDetails = (minTemperature, maxTemperature, temperatureUnit)=> {
        if(this.viewMode) {
            return;
        }
        this.cargoInfo.setTemperatureSensitive(minTemperature, maxTemperature, temperatureUnit);
        this.setState({
            cargoInfo: this.cargoInfo,
            isTemperatureCardShown: false
        })
    }

    changeCargoType = (value) => {
        if(this.viewMode) {
            return;
        }
        this.cargoInfo.setCargoType(value);
        this.setState({
            cargoInfo: this.cargoInfo
        });
    }
    onDescriptionChange = (e) => {
        if(this.viewMode) {
            return;
        }
		 this.cargoInfo.setCargoDescription(toPascalCase(e.target.value));
        this.setState({
            cargoInfo: this.cargoInfo
        });
    }
    getCargoList = (rfqType)=>{ 
        
       if(isMITSUI()){
         return (CARGO_DETAILS || []).filter(cargo => ![6, 7].includes(cargo.value))
       }

        return ((rfqType === 5 && HIKAL.includes(getUser().companyId)) 
        ? CARGO_DETAILS.filter(el => ![5,6,7].includes(el.value)) 
        : (rfqType === 6 
            ? CARGO_DETAILS 
            : (CARGO_DETAILS || []).filter(cargo => ![6, 7].includes(cargo.value))))
        // return ((rfqType === 5 && HIKAL.includes(getUser().companyId)) ? CARGO_DETAILS.filter(el => ![5,6,7].includes(el.value)) : (rfqType === 6 ? CARGO_DETAILS : (CARGO_DETAILS || []).filter(cargo => ![6, 7].includes(cargo.value))))
        
    }
    render() {
        const { packingTypes,productCategories, submitted, rfqType } = this.props;
        const name = getCompanyName();
        const companyType = (name && name.includes(IS_RIL_RETAIL));
        const isCargil = CARGIL.includes(getUser().companyId);
        const isDPL = DEEPAK_PHENOLICS.includes(getUser().companyId);
        const isGalaxySurface = GALAXY_SURFACE.includes(getUser().companyId);
        const isSapDPL = DEEPAK_PHENOLICS_SAP.includes(getUser().companyId);
        return (
            <div className="box-shadow ph-20 pv-20 br-5">
                <div className="fBold fs-22 border-bottom-light lh-40p mb-30">
                    Cargo Information
                </div>

                {rfqType === 5 && HIKAL.includes(getUser().companyId) && <div className="fBold fs-18 mb-10 header-medium-color">
                    Cargo Type<sup className="danger-color ml-2 pr t-4">*</sup>
                    {submitted && !this.cargoInfo.cargoDetails.length && <span className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Atleast One</span>}
                    <div className="flex flex-wrap fSemibold header-dark-color mt-10">
                        {(CARGO_TYPE || []).map(el =>( <Checkbox label={el.name} checked = {this.cargoInfo.cargoType === el.value} className="mr-20 mb-5" onCheck={() => this.changeCargoType(el)}/>))}
                    </div>
                </div>}
                {rfqType !== 9 && <>
                <div className="fBold fs-18 mb-10 header-medium-color">
                    Cargo Details<sup className="danger-color ml-2 pr t-4">*</sup>
                    {submitted && !this.cargoInfo.cargoDetails.length && <span className="error-color fs-14 fSemibold op-7 ml-5 mt-5">Please Select Atleast One</span>}
                </div>
                <div className={ClassNames("flex flex-wrap mb-40", )}>
                    {
                        this.getCargoList().map((cargo, index)=> {
                            return (
                                <div 
                                    className={ClassNames("border-white tCenter wt-100 ml-10 mr-10 pt-10 pb-10", {
                                        'box-shadow select-icon border-theme br-5': this.cargoInfo.cargoDetails.indexOf(cargo.value) > -1
                                    })} 
                                    key={cargo.value}
                                    name={cargo.value}
                                    onClick={this.toggleCargo}
                                >
                                    
                                    {cargo.value ===1 && <SolidIcon />}
                                    {cargo.value ===2 && <LiquidIcon />}
                                    {cargo.value ===3 && <PackedLiquidIcon />}
                                    {cargo.value ===4 && <GasIcon />}
                                    {cargo.value ===5 && <HazardousIcon />}
                                    {cargo.value ===6 && <SolidIcon />}
                                    {cargo.value ===7 && <ForkLiftIcon />}
                                    {cargo.value ===8 && <Others width={'35px'}  height={'35px'} />}
                                    <div className={ClassNames("mt-10 fs-16 fBold tCenter", {
                                        'theme-color ': this.cargoInfo.cargoDetails.indexOf(cargo.value) > -1,
                                        'label-color ': !(this.cargoInfo.cargoDetails.indexOf(cargo.value) > -1)
                                    })}>{cargo.name}</div>
                                </div>
                            )
                        })
                    }
                </div>
          

                {!isDesmet() && <Fragment>
                        <div className="fBold fs-18 mb-10 header-medium-color">
                            Cargo Description
                        </div>
                        <div className="mb-40">
                            <Input
                                name="Cargo Description"
                                placeholder="Description"
                                value={this.cargoInfo.cargoDescription}
                                onChange={this.onDescriptionChange}
                            />
                        </div>
                    </Fragment>}

                    {isDesmet() && <Fragment>
                        <CargoDescription
                        // handleDownloadCargoMaterialPackingTemaplateFile={
                        //     handleDownloadCargoMaterialPackingTemaplateFile
                        // }
                        // handleOnChangeForCargoMaterialPackingTemplateFile={
                        //     handleOnChangeForCargoMaterialPackingTemplateFile
                        // }
                        material_packing_list={this.material_packing_list}
                        // handleOnClickForAddMaterialPackingBtn={
                        //     handleOnClickForAddMaterialPackingBtn
                        // }
                        // handleOnClickForRemoveMaterialPackingBtn={
                        //     handleOnClickForRemoveMaterialPackingBtn
                        // }
                        // handleOnChangeForMaterialPackingInputs={
                        //     handleOnChangeForMaterialPackingInputs
                        // }
                        // packingTypesList={packingTypesList}
                        />
                        <Spacer spacing={"10px"} />
                    </Fragment>}



                {
                    !companyType &&
                    <React.Fragment>
                        <div className="fBold fs-18 mb-10 header-medium-color">
                            Product Category {isSapDPL && <sup className="danger-color ml-2 pr t-4">*</sup>}
                        </div>
                        {(isCargil || isDPL) ?
                            <Select
                                isMulti
                                className="mb-30 wt-250"
                                value={Array.isArray(this.cargoInfo.productCategory) ? this.cargoInfo.productCategory : (productCategories.filter((productCategory)=> {
                                    return productCategory.value === this.cargoInfo.productCategory
                                }))  || null}
                                options={productCategories}
                                getOptionLabel={(option) => option.name}
                                onChange = {(option) => this.selectProductCategory(option, true)}
                            /> 
                        :
                        <Dropdown 
                            items={productCategories} 
                            label="Choose Product Category" 
                            displayKey="name" 
                            selectedItem={productCategories.find((productCategory)=> {
                                return productCategory.value === this.cargoInfo.productCategory
                            })}
                            onSelect = {this.selectProductCategory}
                            className="mb-30 wt-250"
                        />}
                    </React.Fragment>
                }

                    { !isDesmet() && <Fragment >
                        <div className="fBold fs-18 mb-10 header-medium-color">
                            Packaging Type
                            {!isGalaxySurface && <sup className="danger-color ml-2 pr t-4">*</sup>}
                        </div>
                        {isCargil ?
                            <div className='mb-30'>
                                <Select
                                    id="packagingType"
                                    isMulti
                                    className="mb-5 wt-250"
                                    value={(Array.isArray(this.cargoInfo.packingType) ? this.cargoInfo.packingType : (packingTypes.filter((packingType) => packingType.value === this.cargoInfo.packingType))) || null}
                                    options={packingTypes}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(option) => this.selectPackingType(option, true)}
                                />
                                {submitted && !packingTypes.find((packingType) => {
                                    return packingType.value === this.cargoInfo.packingType
                                }) && <div className="error-color fs-14 fSemibold op-7 ml-5">Please Select The Field</div>}
                            </div>
                            : <Dropdown
                                items={packingTypes}
                                label="Choose Packing Type"
                                displayKey="name"
                                selectedItem={packingTypes.find((packingType) => {
                                    return packingType.value === this.cargoInfo.packingType
                                })}
                                onSelect={this.selectPackingType}
                                className="mb-30 wt-250"
                                hasError={submitted && !isGalaxySurface && !packingTypes.find((packingType) => {
                                    return packingType.value === this.cargoInfo.packingType
                                })}
                            />}
                    </Fragment>}


                </>}
                <div className="fBold fs-18 mb-10 header-medium-color">
                    Handling Instructions
                </div>
                <div className={ClassNames("flex flex-wrap mb-40 max-wt-700", )}>
                    {
                        HANDLING_INSTRUCTIONS.map((instruction, index)=> {
                            return (
                                <div 
                                    className={ClassNames("pr border-white tCenter wt-100 mb-10 ml-10 mr-10 pt-10 pb-10", {
                                        'box-shadow select-icon border-theme br-5': this.cargoInfo.handlingInstructions.indexOf(instruction.value) > -1
                                    })} 
                                    key={instruction.value}
                                    name={instruction.value}
                                    onClick={this.toggleInstructions}
                                >
                                
                                    {instruction.value === 2 && this.state.isTemperatureCardShown && <OutsideClickHandler
                                            onOutsideClick={() => {
                                                this.setState({isTemperatureCardShown: false});
                                            }}
                                        >
                                            <div className="pa z-1 r-0 l-100p ml-20">
                                                <TemperatureCard saveTemperatureDetails={this.saveTemperatureDetails} minimum={this.cargoInfo.temperatureSensitive.min} maximum={this.cargoInfo.temperatureSensitive.max} temperatureUnit={this.cargoInfo.temperatureSensitive.unit}/>
                                            </div>
                                        </OutsideClickHandler>
                                    }
                                    {instruction.value ===1 && <NormalIcon />}
                                    {instruction.value ===2 && <TemperatureSensitiveIcon />}
                                    {instruction.value ===3 && <Sunlight />}
                                    {instruction.value ===4 && <HygroscopicIcon />}
                                    {instruction.value ===5 && <HandleWithCareIcon />}
                                    {instruction.value ===6 && <VerticalLoadingIcon />}
                                    {instruction.value ===7 && <ImpactSensitiveIcon />}
                                    {instruction.value ===8 && <ForkLiftIcon />}
                                    {instruction.value ===9 && <HydraIcon />}
                                    {instruction.value ===10 && <CraneIcon />}
                                    <div className={ClassNames("mt-10 fs-16 fBold tCenter", {
                                        'theme-color ': this.cargoInfo.handlingInstructions.indexOf(instruction.value) > -1,
                                        'label-color ': !(this.cargoInfo.handlingInstructions.indexOf(instruction.value) > -1)
                                    })}>{instruction.name}</div>
                                </div>
                            )
                        })
                    }
                </div>
                
            </div>
        )
    }
}

export default CargoInformation;
